import { useEffect } from "react";
import { usePusher } from "./PusherProvider";
export const usePusherChannel = (channelName, eventName, callback, useGeneralChat = false) => {
  const { pusher, generalChatPusher } = usePusher();
  const activePusher = useGeneralChat ? generalChatPusher : pusher;

  useEffect(() => {
    if (!activePusher || !channelName || !eventName) return;
    
    const channel = activePusher.subscribe(channelName);
    channel.bind(eventName, callback);

    return () => {
      channel.unbind(eventName, callback);
      activePusher.unsubscribe(channelName);
    }

  }, [activePusher, channelName, eventName, callback])
}